import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'
import { COLORS } from '../data/enums'

export default function FaceFeature({
  scaleX,
  scale,
  gradient,
  pupil,
  rotation = 0,
  spacing = 0,
  verticalOffset,
  outline,
  showEyeLiner,
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftPupilTransformOrigin = '16.22 14.15'
  const rightPupilTransformOrigin = '43.22 14.15'
  return (
    <>
      <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
        {/* LEFT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${-spacing})`} transform-origin={leftPupilTransformOrigin}>
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            {/* SCLERA */}
            <path
              className="cls-2"
              d="M6.73,13.01s3.79-6.38,10.23-5.25c6.07,1.07,7.77,10.56,7.77,10.56,0,0-4.24,3.18-10.15,2.07-6.32-1.16-7.85-7.38-7.85-7.38Z"
              fill={COLORS.WHITE}
            />
            {/* EYE LID */}
            <path
              className="cls-3"
              d="M17.1,21.13c-.83,0-1.7-.07-2.62-.24-6.56-1.2-8.23-7.69-8.25-7.76l-.05-.2,.1-.18c.04-.07,4.05-6.66,10.75-5.49,6.34,1.12,8.1,10.56,8.17,10.96l.05,.3-.25,.18c-.15,.11-3.28,2.41-7.92,2.41ZM7.27,13.1c.32,1.06,2.04,5.83,7.4,6.81,4.82,.9,8.52-1.18,9.5-1.81-.36-1.62-2.25-8.95-7.29-9.84-5.43-.95-8.95,3.85-9.61,4.84Z"
              fill={outline}
            />
          </g>
          {/* IRIS */}
          <path
            className="cls-1"
            d="M16.23,19.63c3.04,0,5.5-2.46,5.5-5.5s-2.46-5.5-5.5-5.5-5.5,2.46-5.5,5.5,2.46,5.5,5.5,5.5Z"
            fill={`url(#${randomGradientId1})`}
          />
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            {/* PUPIL */}
            <path
              className="cls-4"
              d="M16.22,16.9c1.52,0,2.75-1.23,2.75-2.75s-1.23-2.75-2.75-2.75-2.75,1.23-2.75,2.75,1.23,2.75,2.75,2.75Z"
              fill={pupil}
            />
            {/* EYE LINER */}
            {showEyeLiner && (
              <path d="M6.19,12.93c3.44-7.62,12.89-8.58,16.86-.84,1.14,2.02,1.9,4.2,2.22,6.45-1-2.02-2.08-3.97-3.35-5.72-4.34-6.53-11-5.21-15.73,.11h0Z" />
            )}
          </g>
          {/* TWINKLE */}
          <path
            className="cls-2"
            d="M18.06,13.21c.51,0,.92-.41,.92-.92s-.41-.92-.92-.92-.92,.41-.92,.92,.41,.92,.92,.92Z"
            fill={COLORS.WHITE}
          />
        </g>
        {/* RIGHT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${spacing})`} transform-origin={rightPupilTransformOrigin}>
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path
              className="cls-2"
              d="M52.73,13.01s-3.79-6.38-10.23-5.25c-6.07,1.07-7.77,10.56-7.77,10.56,0,0,4.24,3.18,10.15,2.07,6.32-1.16,7.85-7.38,7.85-7.38Z"
              fill={COLORS.WHITE}
            />
            <path
              className="cls-3"
              d="M42.35,21.13c-4.65,0-7.77-2.29-7.92-2.41l-.25-.18,.05-.3c.07-.4,1.83-9.84,8.17-10.96,6.7-1.18,10.71,5.42,10.75,5.49l.1,.18-.05,.2c-.02,.07-1.68,6.55-8.25,7.76-.91,.17-1.79,.24-2.61,.24Zm-7.07-3.04c.98,.63,4.69,2.71,9.5,1.81,5.37-.98,7.09-5.75,7.4-6.81-.66-.99-4.17-5.8-9.61-4.84-5.05,.89-6.94,8.22-7.29,9.84Z"
              fill={outline}
            />
          </g>
          <path
            className="cls-5"
            d="M43.23,19.63c3.04,0,5.5-2.46,5.5-5.5s-2.46-5.5-5.5-5.5-5.5,2.46-5.5,5.5,2.46,5.5,5.5,5.5Z"
            fill={`url(#${randomGradientId2})`}
          />
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path
              className="cls-4"
              d="M43.22,16.9c1.52,0,2.75-1.23,2.75-2.75s-1.23-2.75-2.75-2.75-2.75,1.23-2.75,2.75,1.23,2.75,2.75,2.75Z"
              fill={pupil}
            />
            {showEyeLiner && (
              <path d="M34.16,18.54c.84-4.42,2.95-9.4,7.37-11.32,4.72-1.87,9.99,1.32,11.71,5.72-8.63-8.67-14.76-3.98-19.08,5.6h0Z" />
            )}
          </g>
          <path
            className="cls-2"
            d="M45.06,13.21c.51,0,.92-.41,.92-.92s-.41-.92-.92-.92-.92,.41-.92,.92,.41,.92,.92,.92Z"
            fill={COLORS.WHITE}
          />
        </g>
      </g>

      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="16.23"
          y1="178.13"
          x2="16.23"
          y2="189.48"
          gradientTransform="translate(0 198) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="43.23"
          y1="178.13"
          x2="43.23"
          y2="189.48"
          gradientTransform="translate(0 198) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </>
  )
}
